import { IGeneralLang, GENERAL_LANG_KEY } from './interface.IGeneralLang'

export * from './interface.IGeneralLang'

export type IGeneralAllLang =
	& IGeneralLang

export const GENERAL_ALL_LANG_KEY: IGeneralAllLang = {
	...GENERAL_LANG_KEY,
}
